import { STEP_TO_ROUTE, type BranchPath, type OnboardingState, type OnboardingStep } from '@/api/onboarding'

export interface AdsEntryTarget {
  href: string
  bookmarkStep?: OnboardingStep | null
  bookmarkBranchPath?: BranchPath | null
}

const DEFAULT_ADS_TARGET: AdsEntryTarget = {
  href: '/onboarding/yandex-connect',
  bookmarkStep: 'yandex-connect',
  bookmarkBranchPath: 'ads',
}

const ADS_RESUME_STEPS = new Set<OnboardingStep>([
  'branch',
  'yandex-connect',
  'yandex-done',
  'tariff',
  'requisites',
  'ad-gen-prepare',
  'creatives-editor',
  'campaigns-ready',
])

export function resolveAdsEntryTarget(state?: OnboardingState): AdsEntryTarget {
  if (!state) return DEFAULT_ADS_TARGET

  if (state.hasCampaigns) {
    return { href: '/analytics?section=ads' }
  }

  if (state.branchPath === 'ads' && state.currentStep && ADS_RESUME_STEPS.has(state.currentStep)) {
    const route = STEP_TO_ROUTE[state.currentStep]
    if (route) {
      return {
        href: state.currentStep === 'branch' ? '/onboarding/yandex-connect' : route,
        bookmarkStep: state.currentStep === 'branch' ? 'yandex-connect' : state.currentStep,
        bookmarkBranchPath: 'ads',
      }
    }
  }

  if (state.branchPath === 'ads' && state.currentStep === 'final') {
    return {
      href: '/onboarding/creatives-editor',
      bookmarkStep: 'creatives-editor',
      bookmarkBranchPath: 'ads',
    }
  }

  if (state.hasYandexAuth && state.hasTariff) {
    return {
      href: '/onboarding/creatives-editor',
      bookmarkStep: 'creatives-editor',
      bookmarkBranchPath: 'ads',
    }
  }

  if (state.hasYandexAuth && !state.hasTariff) {
    return {
      href: '/onboarding/tariff',
      bookmarkStep: 'tariff',
      bookmarkBranchPath: 'ads',
    }
  }

  return DEFAULT_ADS_TARGET
}
